module.exports = __webpack_public_path__ + "static/img/xh-logo-banner.466439c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/xh-logo-banner.png
// module id = utj6
// module chunks = 0